import { createBrowserRouter } from 'react-router-dom';

/**
 * createBrowserRouter, with a subscribe that hands each new subscriber the
 * router's current state (ERI-2764).
 *
 * vite-react-ssg creates the router, which starts the route loaders at once,
 * and then renders RouterProvider inside startTransition. RouterProvider reads
 * router.state on its first render and only subscribes later, in a layout
 * effect. A loader that settles in between (WebKit under vite dev, on the
 * location pages) is never passed on, so RouterProvider keeps rendering its
 * uninitialized fallback and the page stays blank. Replaying the current state
 * on subscribe closes that gap; when nothing changed, RouterProvider gets the
 * same state object back and React skips the update.
 */
export const createAppRouter: typeof createBrowserRouter = (routes, opts) => {
  const router = createBrowserRouter(routes, opts);
  const subscribe = router.subscribe.bind(router);
  router.subscribe = (subscriber) => {
    const unsubscribe = subscribe(subscriber);
    subscriber(router.state, { deletedFetchers: [], viewTransitionOpts: undefined, flushSync: false });
    return unsubscribe;
  };
  return router;
};
